module.exports = __webpack_public_path__ + "static/media/xiaomi_battery_4.cadffea3.jpg";